/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../isessionstorage.d.ts" />
/// <reference path="../controllers/screencontrollerbase.ts" />
/// <reference path="../services/apiservice.ts" />
/// <reference path="../services/authenticationservice.ts" />
/// <reference path="../services/UsersService.ts" />
/// <reference path="../iapirequestconfig.ts" />

module App.Common.Controllers {
    'use strict';

    class UserProfileController extends ScreenControllerBase {

        public username: string;

		public password: string;

		public returnState: angular.ui.IState;

		public returnStateParams: angular.ui.IState;

        public static $inject = ['$injector'];
        constructor($injector: angular.auto.IInjectorService) {
			super($injector);
	        this.fullWidth = true;
	        this.notForWindowsAuthenticationUsers();

			this.title = 'User Profile';
			this.warnOnUnsavedChanges = false;

            this.username = this.users.getCurrentUser().username;

			this.returnState = this.$sessionStorage.returnState;
			this.returnStateParams = _.cloneDeep(this.$sessionStorage.returnStateParams || {});
			delete this.$sessionStorage.returnState;
			delete this.$sessionStorage.returnStateParams;
        }

		public initialize(): angular.IPromise<any> {
			return this.$q.resolve(true);
		}

        public useWindowsAuthentication(): boolean {
            return this.authentication.useWindowsAuthentication();
        }

    }

    angular
        .module('app.common.controllers')
        .controller('app.common.controllers.userProfileController', UserProfileController);
}